import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [taxDetailsAllIds, taxDetailsById, allTaxDetailsSelector] =
  resourceSelectors('taxDetails');
